import axios from 'axios'
// import store from '../store'
// import { getToken,removeToken } from '@/utils/auth'
// console.log(process.env.BASE_API)
// 创建axios实例
console.log("'/api'")
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
//   baseURL: "http://127.0.0.1/dataCenter",
  // baseURL: "/api",
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // config.Headers("Access-Control-Allow-Headers", "x-requested-with,Authorization，Content-Type")
  // console.log(getToken())
  // if (getToken()) {
  //   config.headers['Authorization'] = "Bearer " + getToken();// 让每个请求携带自定义token 请根据实际情况自行修改
  //   config.headers["contentType"] = "application/json;charset=utf-8";
  // }else{
  //   config.headers["contentType"] = "multipart/form-data";
  // }
  // config.headers["contentType"] = "application/json;charset=utf-8";
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  
    return response.data
  },
  error => {
    console.log(error)// for debug
    if(error.response && error.response.status == 401){
      removeToken()
      location.reload();
    }
    // Message({
    //   message: error.msg,
    //   type: 'error',
    //   duration: 3 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js